import { render } from "./QueueNavigator.vue?vue&type=template&id=51b4fbbe&scoped=true&ts=true"
import script from "./QueueNavigator.vue?vue&type=script&lang=ts"
export * from "./QueueNavigator.vue?vue&type=script&lang=ts"

import "./QueueNavigator.vue?vue&type=style&index=0&id=51b4fbbe&scoped=true&lang=scss"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b4fbbe"]])

export default __exports__